<template>
  <div>
    <template v-for="(block, index) in blocks" :key="index">
      <h4 v-if="block.title" class="raw-body-2 mb-4">
        {{ i18n(block.title) }}
      </h4>
      <p class="text-[--raw-verydarkgrey] [&:not(:last-child)]:mb-16">
        <InlineMarkdown :message="block.text" /><SourceMarker
          :refs="block.sourceRefs"
          :zone
        />
      </p>
    </template>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'

import InlineMarkdown from '~/scopes/campaign/components/UI/InlineMarkdown.vue'
import SourceMarker from '~/scopes/campaign/components/UI/SourceMarker.vue'
import type { MetalBlock } from '~/scopes/campaign/data/metals/types'

// Blocks render as flat siblings (optional `title` + paragraph). Spacing is
// margin-based — 4px title→text, 16px between blocks — so a title-less block is
// just a paragraph with no wrapper.
//
// The paragraph goes through `InlineMarkdown` so a block can carry a `[^*]` footnote marker
// on the exact word the client marked — copper's water block marks "the Chilean Copper
// Commission", four sentences in, which a trailing marker could not express. `title` stays
// plain interpolation: it is always a `SECTIONS.*` reference shared across all 34 metals, so
// it can't carry per-metal marks.
defineProps<{
  blocks: readonly MetalBlock[]
  /** Tracking surface of the host view, forwarded to each block's citation. */
  zone: string
}>()

const i18n = useI18n()
</script>
